import { Request,BaseApiUrl } from "./api";

// 列表prodoutmaster
export const getProdOutMasterListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdOutMaster/get`, { params: params });
};


//新增
export const addProdOutMaster = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdOutMaster/Post`, params);
};
//编辑
export const editProdOutMaster = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdOutMaster/ModifySave`, params);
};
//编辑出货单状态
export const putProdOutMaster = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdOutMaster/Put`, params);
};
//签收
export const singeProdOutMaster = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdOutMaster/SingeOutMaster`, params);
};
// 获取退转料列表
export const getTransferHistry = (params) => {
  return Request.get(`${BaseApiUrl}/api/ReturAndTransferRecord/get`, { params: params });
};
//添加退转料
export const SaveTransfer = (params) => {
  return Request.post(`${BaseApiUrl}/api/ReturAndTransferRecord/Post`, params);
};
// 获取出货单新增编辑基础数据
export const getGetProdOutMasterBaseData = (params) => {
    return Request.get(`${BaseApiUrl}/api/ProdOutMaster/GetProdOutMasterBaseData`);
};
  
//批量删除
export const batchDeleteProdOutMaster = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProdOutMaster/BatchDelete`, params);
};
// export const batchDeleteProdOutMaster = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/ProdOutMaster/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
//获取施工配比详情
export const getManufactureDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Prodmanufacturemain/GetManufacture`, { params: params });
};

//获取打印详情
export const getPrintContent = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdOutMaster/Print`, { params: params });
};

//获取耗料打印详情
export const getPrintProdmanufacture = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/PrintProdmanufacture`, { params: params });
};